import $ from 'jquery'
// import { createAlert } from 'dom/window';
// import _ from 'lodash';
import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import { segmentTrackOrderCompleted } from '../utils/segment/track'
import config from '../store/_config'
import {
  convertSupplierCartToReact,
  convertCheckoutDetailsToReact,
  convertAvailableDeliveryAddressesToReact,
  buildCheckoutData,
  convertAvailableDeliveryDatesToReact,
  createDummyAvailableDeliveryDates,
} from '../selectors/converterSelectors'
import {
  toggleCheckoutLoading,
  updateDeliveryAddresses,
  updateSelectedAddress,
  updateCart,
  replaceCheckoutCartDetails,
  updateDeliveryDates,
  updateSelectedDeliveryDate,
  setCheckoutGlobalConfig,
  axiosRequestCart,
  axiosRequestCheckoutPaymentMethods,
} from './checkoutActions'
import { clearCart } from './cartSupplierActions'
import { createAlert } from '../dom/window'
import { axiosRequestDeliveryAddresses } from './addressActions'
import { LS } from '../store/localStorage'
import { resetActiveCustomer } from './supplierActions'

export const requestCart = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0

    const readGlobalConfigResponse = await axiosRequestCheckoutPaymentMethods()
    const globalConfig = readGlobalConfigResponse?.data?.data?.readGlobalConfig

    dispatch(setCheckoutGlobalConfig(globalConfig))

    if (customerID) {
      dispatch(toggleCheckoutLoading('cart', true))

      return axiosRequestCart(customerID)
        .then((response) => {
          const cart = response.data.data.readOneCart

          dispatch(toggleCheckoutLoading('cart', false))

          // Cart
          const list = convertSupplierCartToReact(cart, state.user)
          dispatch(updateCart(list))

          // Checkout Detail
          const details = convertCheckoutDetailsToReact(cart)
          details.memberid = customerID
          dispatch(replaceCheckoutCartDetails(details))
        })
        .catch((error) => {
          dispatch(toggleCheckoutLoading('cart', false))
        })
    }
  }
}
export const requestCartDetails = () => {
  return (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0
    let { url, query } = config.checkout.details
    query = query.replace('{supplierID}', window.supplierID)

    dispatch(toggleCheckoutLoading('summary', true))

    axios
      .get(url, {
        withCredentials: true,
        params: {
          query: query,
        },
      })
      .then((response) => {
        dispatch(toggleCheckoutLoading('summary', false))

        if (typeof response.data.data != 'undefined') {
          // Checkout Detail
          const details = convertCheckoutDetailsToReact(response.data.data)
          details.memberid = customerID
          dispatch(replaceCheckoutCartDetails(details))
        } else {
          if (typeof response.errors != 'undefined') {
            createAlert(response.errors[0], 'error')
          }

          console.log('Invalid response')
        }
      })
      .catch((error) => {
        handleAxiosErrors(error)
        dispatch(toggleCheckoutLoading('summary', false))
      })
  }
}
export const requestDeliveryAddresses = () => {
  return (dispatch, getState) => {
    let state = getState()
    // const customerID = state.user.user;
    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0
    const selectedDeliveryAddress =
      state && typeof state.checkout.details.selectedDeliveryAddress != 'undefined'
        ? state.checkout.details.selectedDeliveryAddress
        : ''
    const defaultDeliveryAddressID = state.user.defaultDeliveryAddressID

    if (customerID) {
      dispatch(toggleCheckoutLoading('deliveryAddresses', true))

      return axiosRequestDeliveryAddresses({
        isSupplier: true,
      })
        .then((response) => {
          dispatch(toggleCheckoutLoading('deliveryAddresses', false))

          // Delivery Addresses
          const list = convertAvailableDeliveryAddressesToReact(response.data.data.readAddresss.edges)
          dispatch(updateDeliveryAddresses(list))

          // Refresh state
          state = getState()

          // Do extra if delivery address has been selected
          if (selectedDeliveryAddress) {
            const foundAddress = state.checkout.availableDeliveryAddresses.find((item) => {
              return typeof item.id != 'undefined' && typeof selectedDeliveryAddress != 'undefined'
                ? item.id == selectedDeliveryAddress
                : false
            })

            if (!foundAddress) {
              dispatch(updateSelectedAddress(''))
            }
          } else {
            dispatch(updateSelectedAddress(defaultDeliveryAddressID))
          }
        })
        .catch((error) => {
          dispatch(toggleCheckoutLoading('deliveryAddresses', false))
        })
    }
  }
}
export const requestDeliveryDates = () => {
  return (dispatch, getState) => {
    let state = getState()

    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0
    const selectedDeliveryDate =
      state && typeof state.checkout.details.selectedDeliveryDate != 'undefined'
        ? state.checkout.details.selectedDeliveryDate
        : ''
    // const postcode = state && typeof(state.checkout.details.selectedDeliveryAddressObj.postcode) != 'undefined' ? state.checkout.details.selectedDeliveryAddressObj.postcode : '';

    if (customerID) {
      let { url, query } = config.checkout.deliveryDates
      //query = query.replace('{memberid}', customerID);

      dispatch(toggleCheckoutLoading('deliveryDates', true))

      axios
        .get(url, {
          params: {
            query: query,
          },
          withCredentials: true,
        })
        .then((response) => {
          dispatch(toggleCheckoutLoading('deliveryDates', false))

          let deliveryDates = convertAvailableDeliveryDatesToReact(response.data.data)

          // If no delivery dates given, now we recreate a dummy one
          if (deliveryDates.length <= 0) {
            deliveryDates = createDummyAvailableDeliveryDates()
          }

          if (deliveryDates.length > 0) {
            dispatch(updateDeliveryDates(deliveryDates))

            // Update selected delivery date
            state = getState()

            const foundDeliveryDates = state.checkout.availableDeliveryDates.find((item) => {
              return item.date.toLowerCase() == selectedDeliveryDate.toLowerCase()
            })

            if (!foundDeliveryDates || !selectedDeliveryDate) {
              const recommendedDeliveryDate = state.checkout.availableDeliveryDates.find((item) => {
                return item.available
              })

              let selectedDeliveryDate = state.checkout.availableDeliveryDates[0].date

              if (recommendedDeliveryDate) {
                selectedDeliveryDate = recommendedDeliveryDate.date
              }

              dispatch(updateSelectedDeliveryDate('selectedDeliveryDate', selectedDeliveryDate))
            }
          } else {
            dispatch(updateDeliveryDates(false))
            dispatch(updateSelectedDeliveryDate('selectedDeliveryDate', ''))
          }
        })
        .catch((error) => {
          handleAxiosErrors(error)
          dispatch(toggleCheckoutLoading('deliveryDates', false))
        })
    }
  }
}
export const processPayment = () => {
  return (dispatch, getState) => {
    const state = getState()
    const formData = buildCheckoutData(state.checkout)

    dispatch(toggleCheckoutLoading('summary', true))

    const cartItems = state.checkout.cart.list
    const cartId = state.checkout.cart.id
    const cart = state.checkout.cart

    //update cart first
    axios
      .post(config.checkout.updateCart.url, {
        query: config.checkout.updateCart.query,
        variables: formData,
      })
      .then((response) => {
        //then make the payment
        return axios.post(config.checkout.processPayment.url, {
          query: config.checkout.processPayment.query,
          variables: formData,
        })
      })
      .then((response) => {
        segmentTrackOrderCompleted(cartItems, cartId, cart)
        const order = response.data.data.payForOrder
        dispatch(clearCart())
        dispatch(resetActiveCustomer())
        window.location.href = `/checkout/confirmation/${order.ID}`
      })
      .catch((error) => {
        segmentTrackOrderCompleted(cartItems, cartId, cart)
        LS.set('supplier-paidOrderId', cartId)
        if (error?.message === 'Order has already been paid.') {
          const paidOrderId = LS.get('supplier-paidOrderId')
          dispatch(clearCart())
          dispatch(resetActiveCustomer())
          window.location.href = `/checkout/confirmation/${paidOrderId}`
        }
        handleAxiosErrors(error)
        dispatch(toggleCheckoutLoading('summary', false))
      })
  }
}
